export default __webpack_public_path__ + "static/testimonial-mira-5cd70c1fa457667dd4b13443221c2ade.jpg";